// Disable Gatsby's automatic scroll restoration to prevent jumping
export const shouldUpdateScroll = () => {
  // Return false to prevent Gatsby from handling scroll restoration
  return false;
};

// Handle scroll position after route updates
export const onRouteUpdate = ({ location }) => {
  // Only scroll to top if there's no hash fragment
  if (!location.hash) {
    // Use requestAnimationFrame for smoother scrolling
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }
};
